/**
 * Scansiona la pagina, trova tutte le infografiche e attiva gli observer.
 */
export function initAllInfographics() {
    const wrappers = document.querySelectorAll('.js-infographic-wrapper');

    if (wrappers.length === 0) return;

    // Observer condiviso per performance:
    // Carica la libreria di animazione (Anime.js) solo quando la PRIMA infografica
    // sta per entrare nel viewport.
    const loaderObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Smetti di osservare tutti, ormai carichiamo la lib
                observer.disconnect();

                // Import dinamico del motore di animazione
                loadAnimationEngine(wrappers);
            }
        });
    }, { rootMargin: '200px' }); // Carica un po' prima

    // Osserva tutti i wrapper
    wrappers.forEach(w => loaderObserver.observe(w));
}

function loadAnimationEngine(wrappers) {
    import('./infographic_anim.js')
        .then(module => {
            const runAnimation = module.default;

            // Ora che abbiamo la lib, inizializziamo l'animazione specifica per ogni wrapper
            // Usando un nuovo observer per farle partire al momento giusto (quando sono visibili)
            const playObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        runAnimation(entry.target); // Lancia anime.js su questo specifico wrapper
                        playObserver.unobserve(entry.target); // Esegui una volta sola
                    }
                });
            }, { threshold: 0.4 }); // Parte al 40% visibilità

            wrappers.forEach(w => playObserver.observe(w));
        })
        .catch(err => console.error('Error loading Infographic Anim Engine:', err));
}
